import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { ColorRow, LogoRow, TypographyRow } from './components'

const ThemeFeature = ({ active }) => {
   const [visible, setVisible] = useState(false)

   useEffect(() => {
      if (active) {
         setTimeout(() => {
            setVisible(true)
         }, 200)
      } else {
         setVisible(false)
      }
   }, [active])

   return (
      <div className="w-full h-full">
         <div
            className={classNames(
               'absolute flex flex-col gap-4 -top-[10%] sm:top-[15%] left-[0%] sm:left-[15%] w-[100%] sm:w-[70%] transition-all duration-700 scale-[70%] sm:scale-100',
               visible ? 'translate-y-0' : 'translate-y-10'
            )}>
            <div
               className={classNames(
                  'bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700',
                  visible ? 'translate-y-0 opacity-90' : 'translate-y-10 opacity-0'
               )}>
               <LogoRow />
            </div>
            <div
               className={classNames(
                  'bg-white rounded-2xl overflow-hidden shadow-[0px_10px_30px_rgba(0,0,0,0.3)] transition-all duration-700 delay-50',
                  visible ? 'translate-y-0 opacity-60' : 'translate-y-10 opacity-0'
               )}>
               <ColorRow />
            </div>
            <div
               className={classNames(
                  'transition-all duration-700 delay-100',
                  visible ? 'opacity-100' : 'opacity-0'
               )}>
               <TypographyRow
                  icon="report"
                  number="47,260"
                  subtitle="Last updated a week ago"
                  title="Annual Report"
               />
            </div>
         </div>
      </div>
   )
}

ThemeFeature.propTypes = {
   active: PropTypes.bool.isRequired
}

export default ThemeFeature
